import { createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "upload-modal__inner" }
const _hoisted_2 = { class: "upload-modal__title-heading" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, " Project ", -1 /* HOISTED */)
const _hoisted_4 = { class: "upload-modal__title" }
const _hoisted_5 = {
  key: 1,
  class: "upload-modal__submission-select"
}
const _hoisted_6 = {
  for: "submission",
  class: "form__label"
}
const _hoisted_7 = { class: "form__icon form__icon--down" }
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  disabled: ""
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", { value: "none" }, " No submission ", -1 /* HOISTED */)
const _hoisted_11 = {
  key: 0,
  class: "upload-modal__create-submission-modal"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h3", { class: "upload-modal__create-submission-title" }, " Create submission ", -1 /* HOISTED */)
const _hoisted_13 = { class: "form__set" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "form__label",
  for: "submission-name"
}, " Submission name ", -1 /* HOISTED */)
const _hoisted_15 = { class: "form__set mb-64" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "form__label",
  for: "submission-comment"
}, " Comment ", -1 /* HOISTED */)
const _hoisted_17 = { class: "flex flex--justify-end flex--gap-small" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("button", {
  class: "button button--fill",
  type: "submit"
}, " Create ", -1 /* HOISTED */)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "upload-modal__upload-status" }, null, -1 /* HOISTED */)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "upload-modal__progress-bar" }, null, -1 /* HOISTED */)
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { class: "upload-modal__content" }
const _hoisted_23 = {
  key: 0,
  class: "upload-modal__complete-message"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("p", null, " This project is now complete and further uploading has been disabled. ", -1 /* HOISTED */)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 1,
  class: "upload-modal__complete-message"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", null, " Your files are being processed and will be available to view shortly. ", -1 /* HOISTED */)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", null, " Remember that uploads need to be approved by a PM or Lead Artist before they are visible to clients. ", -1 /* HOISTED */)
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = {
  key: 0,
  class: "upload-modal__errors"
}
const _hoisted_31 = { class: "form__error" }
const _hoisted_32 = {
  key: 2,
  class: "upload-modal__files"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Thumbnail"),
    /*#__PURE__*/_createElementVNode("th", null, "Filename"),
    /*#__PURE__*/_createElementVNode("th", null, "Asset"),
    /*#__PURE__*/_createElementVNode("th", null, "Stage"),
    /*#__PURE__*/_createElementVNode("th", null, "Option"),
    /*#__PURE__*/_createElementVNode("th", null, "Artist"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1 /* HOISTED */)
const _hoisted_34 = ["src", "alt"]
const _hoisted_35 = { class: "upload-modal__filename" }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { class: "form__icon form__icon--down" }
const _hoisted_39 = ["onUpdate:modelValue"]
const _hoisted_40 = ["value"]
const _hoisted_41 = { key: 2 }
const _hoisted_42 = { key: 3 }
const _hoisted_43 = ["onUpdate:modelValue"]
const _hoisted_44 = { class: "form__icon form__icon--down" }
const _hoisted_45 = ["onUpdate:modelValue"]
const _hoisted_46 = {
  key: 1,
  class: "form__icon form__icon--down"
}
const _hoisted_47 = ["onUpdate:modelValue", "disabled"]
const _hoisted_48 = ["value"]
const _hoisted_49 = {
  key: 0,
  value: ""
}
const _hoisted_50 = ["onClick"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { colspan: "6" }
const _hoisted_54 = { class: "upload-modal__errors" }
const _hoisted_55 = {
  key: 0,
  class: "upload-modal__submit-bar"
}
const _hoisted_56 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_drag_drop = _resolveComponent("drag-drop")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Modal header "),
    _createElementVNode("div", {
      class: _normalizeClass(["upload-modal__header", { 'upload-modal__header--less-padding': $props.formatLocked }])
    }, [
      (!$props.formatLocked)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "upload-modal__back",
            "aria-label": "Go back",
            onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit( 'back-to-format-select' )))
          }, " Back "))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("h2", _hoisted_4, _toDisplayString($props.project.title), 1 /* TEXT */)
      ]),
      ($options.awaiting_upload)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              class: _normalizeClass(["form__set form__set--no-margin", { 'form__set--error': $data.errors['submission_id'] }])
            }, [
              _createElementVNode("label", _hoisted_6, [
                _createTextVNode(" Submission "),
                _createElementVNode("button", {
                  class: "upload-modal__add-submission-button",
                  onClick: _cache[1] || (_cache[1] = $event => ($data.show_submission_modal = true))
                }, " (Create submission) ")
              ]),
              _createElementVNode("div", _hoisted_7, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.submission_id) = $event)),
                  class: "form__select"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.submissions_list, (submission) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: `submission-${ submission }`,
                      value: submission.value
                    }, _toDisplayString(submission.label), 9 /* TEXT, PROPS */, _hoisted_8))
                  }), 128 /* KEYED_FRAGMENT */)),
                  ($data.submissions_list && $data.submissions_list.length)
                    ? (_openBlock(), _createElementBlock("option", _hoisted_9, " ––––––––– "))
                    : _createCommentVNode("v-if", true),
                  _hoisted_10
                ], 512 /* NEED_PATCH */), [
                  [_vModelSelect, $data.submission_id]
                ])
              ])
            ], 2 /* CLASS */),
            ($data.show_submission_modal)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createElementVNode("form", {
                    onSubmit: _cache[6] || (_cache[6] = _withModifiers((...args) => ($options.createNewSubmission && $options.createNewSubmission(...args)), ["prevent"]))
                  }, [
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, [
                      _hoisted_14,
                      _withDirectives(_createElementVNode("input", {
                        id: "submission-name",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.new_submission_form.name) = $event)),
                        class: "form__input",
                        type: "text",
                        required: ""
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $data.new_submission_form.name]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _hoisted_16,
                      _withDirectives(_createElementVNode("textarea", {
                        id: "submission-comment",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.new_submission_form.comment) = $event)),
                        class: "form__input",
                        rows: "2"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, $data.new_submission_form.comment]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("button", {
                        class: "button",
                        onClick: _cache[5] || (_cache[5] = (...args) => ($options.cancelSubmissionCreation && $options.cancelSubmissionCreation(...args)))
                      }, " Cancel "),
                      _hoisted_18
                    ])
                  ], 32 /* HYDRATE_EVENTS */)
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass(["upload-modal__progress-wrapper", { 'invisible': $options.awaiting_upload }])
      }, _hoisted_21, 2 /* CLASS */)
    ], 2 /* CLASS */),
    _createCommentVNode(" Modal content "),
    _createElementVNode("div", _hoisted_22, [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          ($props.project.project_status === 'completed' || $props.project.project_status === 'terminated')
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _hoisted_25))
            : ($data.show_complete_message)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_29))
              : (_openBlock(), _createElementBlock("div", {
                  key: 2,
                  id: "image-upload",
                  class: _normalizeClass(["upload-modal__drag-drop flex", { 'upload-modal__drag-drop--hover': $data.hover }])
                }, [
                  ($data.errors['submission_id'])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("p", null, _toDisplayString($data.errors['submission_id']), 1 /* TEXT */)
                        ])
                      ]))
                    : _createCommentVNode("v-if", true),
                  ($data.uppy && $options.awaiting_upload)
                    ? (_openBlock(), _createBlock(_component_drag_drop, {
                        key: 1,
                        uppy: $data.uppy,
                        props: $data.uppy_config
                      }, null, 8 /* PROPS */, ["uppy", "props"]))
                    : _createCommentVNode("v-if", true),
                  (Object.keys( $data.files ).length > 0)
                    ? (_openBlock(), _createElementBlock("table", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.files, (file, file_id) => {
                            return (_openBlock(), _createElementBlock(_Fragment, { key: file_id }, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("td", null, [
                                  (file.preview)
                                    ? (_openBlock(), _createElementBlock("img", {
                                        key: 0,
                                        class: "upload-modal__thumbnail",
                                        src: file.preview,
                                        alt: file.filename
                                      }, null, 8 /* PROPS */, _hoisted_34))
                                    : _createCommentVNode("v-if", true)
                                ]),
                                _createElementVNode("td", _hoisted_35, _toDisplayString(file.filename), 1 /* TEXT */),
                                ($props.asset)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_36, _toDisplayString($props.asset.title), 1 /* TEXT */))
                                  : (_openBlock(), _createElementBlock("td", _hoisted_37, [
                                      (!$options.awaiting_upload)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString($options.assets_list.find( asset => asset.value === file.asset_id ).label), 1 /* TEXT */)
                                          ], 64 /* STABLE_FRAGMENT */))
                                        : (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            class: _normalizeClass(["form__set form__set--no-margin", { 'form__set--error': $data.errors[ file_id ] && $data.errors[ file_id ].asset_id }])
                                          }, [
                                            _createElementVNode("div", _hoisted_38, [
                                              _withDirectives(_createElementVNode("select", {
                                                "onUpdate:modelValue": $event => ((file.asset_id) = $event),
                                                class: "form__select form__select--stretch"
                                              }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.assets_list, (project_asset) => {
                                                  return (_openBlock(), _createElementBlock("option", {
                                                    key: `asset-${ file.filename + '-' + project_asset.value }`,
                                                    value: project_asset.value
                                                  }, _toDisplayString(project_asset.label), 9 /* TEXT, PROPS */, _hoisted_40))
                                                }), 128 /* KEYED_FRAGMENT */))
                                              ], 8 /* PROPS */, _hoisted_39), [
                                                [_vModelSelect, file.asset_id]
                                              ])
                                            ])
                                          ], 2 /* CLASS */))
                                    ])),
                                ($props.stage)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_41, _toDisplayString($props.stage), 1 /* TEXT */))
                                  : (_openBlock(), _createElementBlock("td", _hoisted_42, [
                                      (!$options.awaiting_upload)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString(file.revision), 1 /* TEXT */)
                                          ], 64 /* STABLE_FRAGMENT */))
                                        : (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            class: _normalizeClass(["form__set form__set--no-margin", { 'form__set--error': $data.errors[ file_id ] && $data.errors[ file_id ].revision }])
                                          }, [
                                            _withDirectives(_createElementVNode("input", {
                                              "onUpdate:modelValue": $event => ((file.revision) = $event),
                                              class: "form__input form__input--short",
                                              type: "text"
                                            }, null, 8 /* PROPS */, _hoisted_43), [
                                              [_vModelText, file.revision]
                                            ])
                                          ], 2 /* CLASS */))
                                    ])),
                                _createElementVNode("td", null, [
                                  (!$options.awaiting_upload)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(file.option), 1 /* TEXT */)
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : (_openBlock(), _createElementBlock("div", {
                                        key: 1,
                                        class: _normalizeClass(["form__set form__set--no-margin", { 'form__set--error': $data.errors[ file_id ] && $data.errors[ file_id ].option }])
                                      }, [
                                        _createElementVNode("div", _hoisted_44, [
                                          _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": $event => ((file.option) = $event),
                                            class: "form__select form-select--stretch"
                                          }, [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList([ 1, 2, 3, 4, 5, 6, 7, 8, 9, 10 ], (number) => {
                                              return _createElementVNode("option", {
                                                key: `option-${ number }`
                                              }, _toDisplayString(number), 1 /* TEXT */)
                                            }), 64 /* STABLE_FRAGMENT */))
                                          ], 8 /* PROPS */, _hoisted_45), [
                                            [_vModelSelect, file.option]
                                          ])
                                        ])
                                      ], 2 /* CLASS */))
                                ]),
                                _createElementVNode("td", null, [
                                  (!$options.awaiting_upload)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString($data.staff_list.find( artist => artist.value === file.artist ).label), 1 /* TEXT */)
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                        _withDirectives(_createElementVNode("select", {
                                          "onUpdate:modelValue": $event => ((file.artist) = $event),
                                          class: _normalizeClass(["form__select form-select__stretch", { 'form__select--error': $data.errors[ file_id ] && $data.errors[ file_id ].artist }]),
                                          disabled: !$options.project_staff_list || !$options.project_staff_list.length
                                        }, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.project_staff_list, (user) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: `artist-${ user.value }`,
                                              value: user.value
                                            }, _toDisplayString(user.label), 9 /* TEXT, PROPS */, _hoisted_48))
                                          }), 128 /* KEYED_FRAGMENT */)),
                                          (!$options.project_staff_list || !$options.project_staff_list.length)
                                            ? (_openBlock(), _createElementBlock("option", _hoisted_49, " No artists on project "))
                                            : _createCommentVNode("v-if", true)
                                        ], 10 /* CLASS, PROPS */, _hoisted_47), [
                                          [_vModelSelect, file.artist]
                                        ]),
                                        (file.artist && Object.values( $data.files ).length > 1)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              class: "form__copy-value",
                                              onClick: $event => ($options.copyArtistToAll( file.artist ))
                                            }, " Select artist for all ", 8 /* PROPS */, _hoisted_50))
                                          : _createCommentVNode("v-if", true)
                                      ]))
                                ]),
                                _createElementVNode("td", null, [
                                  ($options.awaiting_upload)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "upload-modal__remove-file",
                                        onClick: $event => ($options.removeFile( file_id ))
                                      }, null, 8 /* PROPS */, _hoisted_51))
                                    : _createCommentVNode("v-if", true)
                                ])
                              ]),
                              ($data.errors[ file_id ])
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_52, [
                                    _createElementVNode("td", _hoisted_53, [
                                      _createElementVNode("div", _hoisted_54, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.errors[ file_id ], (error, error_id) => {
                                          return (_openBlock(), _createElementBlock("div", {
                                            key: `error-${ error_id }`,
                                            class: "form__error"
                                          }, [
                                            _createElementVNode("p", null, _toDisplayString(error), 1 /* TEXT */)
                                          ]))
                                        }), 128 /* KEYED_FRAGMENT */))
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("v-if", true)
                            ], 64 /* STABLE_FRAGMENT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]))
                    : _createCommentVNode("v-if", true)
                ], 2 /* CLASS */))
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _createCommentVNode(" Modal submit bar "),
    (Object.keys( $data.files ).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
          _createElementVNode("p", null, _toDisplayString($options.getTotalFileSize( $options.uppy_files )), 1 /* TEXT */),
          _createElementVNode("button", {
            class: "button button--fill",
            disabled: !$options.awaiting_upload,
            onClick: _cache[7] || (_cache[7] = (...args) => ($options.submitUpload && $options.submitUpload(...args)))
          }, " Upload ", 8 /* PROPS */, _hoisted_56)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}